<template>
  <the-honor :data="honor" />
</template>

<script>
import TheHonor from '@/components/TheHonor'

export default {
  components: { TheHonor },
  async asyncData({ app, $winstonLog }) {
    // 极致荣誉
    try {
      const honor = await app.$axios.get('/wbhome/honorList')
      return { honor: (honor.data && honor.data.data) || [] }
    } catch ({ response }) {
      const { status, statusText, config } = response || {}
      $winstonLog.error(`${new Date()} ${config.url} ${status} ${statusText}`)
      return { honor: [] }
    }
  },
}
</script>
